import type { ITEToken } from '@timeedit/types';
import type { TPermissionRequirements } from '@timeedit/types/lib/types/permissions.type';
import { hasPermissions } from '@timeedit/types/lib/utils/permissionCalculator';

export const getVisibility = ({
  environments = undefined,
  minimumPermissions = undefined,
  authUser = undefined,
}: {
  environments?: string[];
  minimumPermissions?: TPermissionRequirements;
  authUser?: ITEToken;
}) => {
  let isVisible =
    environments?.length && import.meta.env.VITE_TE_APP_ENV
      ? environments.includes(import.meta.env.VITE_TE_APP_ENV)
      : true;
  if (
    isVisible &&
    (minimumPermissions?.scopes?.length ||
      minimumPermissions?.permissions?.length)
  )
    isVisible = calculatePermissions(authUser, minimumPermissions);
  return isVisible;
};

export const calculatePermissions = (
  authUser: ITEToken | undefined,
  { permissions, scopes }: TPermissionRequirements
) => {
  if (!authUser) return false;

  const hasAccess = (req: TPermissionRequirements) =>
    hasPermissions(authUser.appPermissions, authUser.scopes, req);

  return (
    (!!permissions && hasAccess({ permissions })) ||
    (!!scopes && hasAccess({ scopes }))
  );
};

// the user must have TE_ADMIN::admin scope or TE_ADMIN::manageObjects permission to manage objects
export const canManageObjects = (authUser: ITEToken | undefined) => {
  return getVisibility({
    authUser,
    minimumPermissions: {
      scopes: ['TE_ADMIN::admin'],
      permissions: ['TE_ADMIN::manageObjects'],
    },
  });
};
